import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import history from 'service/customHistory';

import { routeState } from 'components/common/Managers/RouteStateManager.state';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';
import * as K from 'common/constants';
import { AccountType } from 'common/graphqlTypes';
import { accountDataState } from 'components/account/account.state';

/**
 * Handles Trial Expired use case across the App
 *  If access expired: user will be redirected to the billing plan page & notified with a dialog
 */
// #region useTrialExpiredHandling
const accessibleRoutes: string[] = [K.ROUTE.PLAN, K.ROUTE.MANAGE_TEAMS];

export function useTrialExpiredHandling(accountType: AccountType | undefined, isTrialExpired: boolean): void {
  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);
  const currentRoute = useRecoilValue(routeState);
  const account = useRecoilValue(accountDataState);
  const isMasterAccount = account.id === account.masterAccountId;
  // Redirect logic
  useEffect(() => {
    if (K.IS_DEVELOPMENT || accountType !== K.TRIAL || accessibleRoutes.includes(currentRoute)) {
      return;
    }

    if (isTrialExpired) {
      history.push(K.ROUTE.PLAN);
    }
  }, [accountType, currentRoute, isTrialExpired]);

  const message = `Your trial has ended - please ${
    isMasterAccount ? '' : 'have the master account holder'
  } provide a credit card and choose a plan, 
      or contact sales@scalyr.com`;

  // User Notification logic
  useEffect(() => {
    if (K.IS_DEVELOPMENT || accountType !== K.TRIAL) {
      return;
    }

    if (isTrialExpired) {
      setTimeout(() => {
        setPageAlertConfig({
          message: message,
          variant: PageAlertVariant.WARNING,
          containerClassName: 'AccountBadge__Warning',
        });
      }, 0);
    }
  }, [accountType, isTrialExpired, setPageAlertConfig]);
}
// #endregion
